@if (showContent) {
  <div class="container-cus-block">
    <div class="acc-sec-content">
      <div class="customer-block-title">
        {{ 'common.header_changecustomer_id' | cxTranslate }}
      </div>
      <mat-select [(ngModel)]="selectedOption" [disabled]="options.length === 1" (ngModelChange)="setNewCustomerId()">
        @for (opt of options; track opt) {
          <mat-option [value]="opt?.uid" [ngClass]="opt?.orderBlocked ? 'bgGrey':''">
            @if (opt?.salesArea1) {
              <span> {{opt?.salesArea1}}&nbsp;|&nbsp;</span>
            }
            @if (opt?.salesArea2) {
              <span>{{opt?.salesArea2 |cxTranslate}}&nbsp;|&nbsp;</span>
            }
            @if (opt?.salesArea3) {
              <span> {{opt?.salesArea3 }}</span>
            }
          </mat-option>
        }
      </mat-select>
    </div>
  </div>
}